import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {SharedService} from "../../shared/shared.service";
import {SharedDataService} from "../../shared/shared-data.service";
import {DtoBranchUser} from "../../shared/models/DtoBranchUser";
import {DtoCashregItem} from "./models/DtoCashregItem";
import {CashregWeekService} from "./cashreg-week.service";


@Component({
    selector: 'app-administration-cashreg-week',
    template: require('./cashreg-week.component.html'),
    styles: [require('./cashreg-week.component.css')]
})

@AutoUnsubscribe()
export class CashregWeekComponent implements OnInit {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    filterHeaderConfig: PageHeaderBarConfig = {
        title: 'INSTELLINGEN',
        buttonDefinition: [
            {
                description: 'BEKIJKEN',
                isSmall: false,
                clickEventType: 'search'
            }
        ]
    };
    pshbConfig: PageSubheaderBarConfig = {
        title: 'WEEKSTAAT',
        buttonDefinition: [
            {
                description: 'EXCEL',
                isSmall: false,
                clickEventType: 'excel'
            }
        ]
    };
    years: Array<{ text: string, value: number }> = [];
    weeks: Array<{ text: string, value: number }> = [];
    filterForm: FormGroup = this.fb.group({
        year: this.ss.getCurrentYear(),
        week: this.ss.getCurrentWeek()
    });

    branches: DtoBranchUser[];
    data: DtoCashregItem[];
    excelFilename: string;
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '240px'
        },
        {
            key: 'branches[0].amount',
            label: 'Hoofdvestiging',
            type: 'currency',
            width: `${this.ss.CalculateColumnWidth('Hoofdvestiging')}px`,
            format: '{0:n2}'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ds: CashregWeekService,
                private ss: SharedService,
                private sds: SharedDataService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'administratie', isLastStep: false },
            { text: 'weekstaat', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');

        for (let i = 0; i < 5; i++) {
            this.years.push({
                text: (this.ss.getCurrentYear() - i).toString(),
                value: this.ss.getCurrentYear() - i
            });
        }

        for (let i = 1; i <= 53; i++) {
            this.weeks.push({
                text: i.toString(),
                value: i
            });
        }

        this.sds.getBranches().subscribe((res: DtoBranchUser[]) => {
            this.branches = res;
            for (let i = 0; i < this.branches.length; i++) {
                this.columnDefinition.push({
                    key: `branches[${i + 1}].amount`,
                    label: this.branches[i].companyName,
                    type: 'currency',
                    width: `${this.ss.CalculateColumnWidth(this.branches[i].companyName)}px`,
                    format: '{0:n2}'
                });
            }
            setTimeout(() => {
                this.loadData();
            });
        });
    }

    loadData() {
        this.excelFilename = `weekstaat - ${this.filterForm.get('year').value} - week ${this.filterForm.get('week').value}.xlsx`;
        this.ds.getCashregByWeek(this.filterForm.get('year').value, this.filterForm.get('week').value).subscribe((res: DtoCashregItem[]) => {
            this.data = res;
            this.grid.showData(this.data);
            this.grid.fitColumns();
        });
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        }
    }

    pshbBtnClicked(event) {
        if (event == 'excel') {
            this.grid.saveAsExcel();
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/administration/cashreg-week/cashreg-week.component.ts